// extracted by mini-css-extract-plugin
export default {"loading":"setPost_loading__Qh6Wz","pcWrap":"setPost_pcWrap__EBW-4"};